// extracted by mini-css-extract-plugin
module.exports = {"admin":"Admin_admin__TBvPU","admin__row":"Admin_admin__row__3IXCA","admin__row__top":"Admin_admin__row__top__33ARi","admin__row__user":"Admin_admin__row__user__2cjrA"};